export class SelectItem<Value> {
  public constructor(
    public readonly label: string,
    public readonly value: Value,
  ) {}
}
